import { type ReactNode } from 'react'
import { RadioGroupItem } from '~/shadcn/ui/radio-group'
import { Label } from '~/shadcn/ui/label'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  score?: number
  value: string
  label: ReactNode
}

export function ScoreRadio({ score, value, label }: Props) {
  return (
    <Label
      data-score={score}
      data-value={value}
      className={cn('flex items-start gap-2 cursor-pointer text-base', 'ml-0')}>
      <RadioGroupItem value={value} id={value} />
      <span className="font-medium">{label}</span>
    </Label>
  )
}
